import type { Asset } from '@storyblok-types';
import { calculateFocalPoint } from '$lib/utilities/storyblok';

const focalPointClasses = {
  center: 'object-center',
  left: 'object-left',
  right: 'object-right',
};

const backgroundFocalPointClasses = {
  center: 'bg-center',
  left: 'bg-left',
  right: 'bg-right',
};

export const getFocalPointClasses = (asset: Asset | undefined) => {
  if (!asset) {
    return '';
  }
  const focalPoint = calculateFocalPoint(asset);
  return focalPointClasses[focalPoint];
};

export const getBackgroundFocalPointClasses = (asset: Asset | undefined) => {
  if (!asset) {
    return '';
  }
  const focalPoint = calculateFocalPoint(asset);
  return backgroundFocalPointClasses[focalPoint];
};
